import { render, staticRenderFns } from "./SignupMember.vue?vue&type=template&id=a961d2ea"
import script from "./SignupMember.vue?vue&type=script&lang=ts"
export * from "./SignupMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports